import React, { useCallback, useEffect, useMemo, useRef } from "react";

import {
  LOAD_INCIDENTS,
  unloadIncidentsAction,
} from "cortex/ui/src/fleet/redux-store/ui-state/incidents/actions";
import {
  incidentsSelector,
  incidentsStoresLoadedSelector,
} from "cortex/ui/src/fleet/redux-store/ui-state/incidents/selectors";
import {
  useAppDispatch,
  useAppSelector,
  useFeatureFlag,
} from "cortex/ui/src/hooks";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas";
import { usersStoresLoadedSelector } from "cortex/ui/src/redux-store/users/selectors";
import { Container } from "cortex/ui/src/view/layout";

import TabbedIncidentsTable from "./TabbedIncidentsTable";

export default function IncidentsList() {
  const isGroupedTriggeredAlertsEnabled = useFeatureFlag(
    "is-grouped-triggered-alerts",
  );
  const dispatch = useAppDispatch();
  const incidents = useAppSelector(incidentsSelector);
  const incidentsStoresLoaded = useAppSelector(incidentsStoresLoadedSelector);
  const usersStoresLoaded = useAppSelector(usersStoresLoadedSelector);
  const storesLoaded = useMemo(
    () => incidentsStoresLoaded && usersStoresLoaded,
    [incidentsStoresLoaded, usersStoresLoaded],
  );
  const filterApiRef = useRef<any>(null);

  const loadIncidents = useCallback(() => {
    return createPromiseApiAction(dispatch, LOAD_INCIDENTS);
  }, [dispatch]);

  useEffect(() => {
    loadIncidents();
  }, [loadIncidents]);

  useEffect(() => {
    return () => {
      dispatch(unloadIncidentsAction);
    };
  }, [dispatch]);

  const tableData = useMemo(() => {
    return filterApiRef.current
      ? filterApiRef.current.getFilteredData(incidents)
      : incidents;
  }, [incidents]);

  return (
    <Container
      gap={1}
      title={isGroupedTriggeredAlertsEnabled ? "Incidents" : "Triggered Alerts"}
    >
      <TabbedIncidentsTable
        sizePerPage={25}
        storesLoaded={storesLoaded}
        tableData={tableData}
      />
    </Container>
  );
}
